import React, { useEffect, useRef, useState } from "react";
import { Player } from "@remotion/player";
import logger from "../../../../../utils/LoggerFrontend.js";
import { TikTokVideo } from "@talentbait/remotion-templates-talentbait";
import { DEFAULT_PLAYER_DATA, TIKTOK_VIDEO_FPS } from "./VideoGenerator__Preview.constants";

const DURATION_IN_FRAMES = TIKTOK_VIDEO_FPS * 20; // 20 seconds x 15 fps = 300

/**
 * VideoGeneratorPreview component
 *
 * @param {{height: number, width: number, videoData: Object}} params - Props
 */
const VideoGeneratorPreview = ({ height, width, videoData }) => {
  const playerRef = useRef(null);
  const [videoPlayerData, setVideoPlayerData] = useState(DEFAULT_PLAYER_DATA);

  useEffect(() => {
    logger.log("VideoGeneratorPreview:useEffect", "called", { videoData });
    if (!videoData) return;

    const {
      audioUrl,
      benefits,
      imageUrl,
      logoUrl,
      primaryTextColor,
      primaryBackgroundColor,
      titleColor,
      mainColor,
      outroText,
      CTAText,
      title
    } = videoData;

    const playerData = {
      title: title || DEFAULT_PLAYER_DATA.title,
      primaryTextColor: titleColor || primaryTextColor || DEFAULT_PLAYER_DATA.primaryTextColor,
      primaryBackgroundColor:
        mainColor || primaryBackgroundColor || DEFAULT_PLAYER_DATA.primaryBackgroundColor,
      benefits: benefits || DEFAULT_PLAYER_DATA.benefits,
      outroText: outroText || DEFAULT_PLAYER_DATA.outroText,
      CTAText: CTAText || DEFAULT_PLAYER_DATA.CTAText,
      logoUrl: logoUrl || DEFAULT_PLAYER_DATA.logoUrl,
      audioUrl: audioUrl || DEFAULT_PLAYER_DATA.audioUrl,
      imageUrl: imageUrl || DEFAULT_PLAYER_DATA.imageUrl
    };

    setVideoPlayerData(playerData);
  }, [videoData]);

  useEffect(() => {
    logger.log("VideoGeneratorPreview:useEffect", "called", { videoPlayerData });

    resetVideo();
  }, [videoPlayerData]);

  const resetVideo = () => {
    const { current } = playerRef;
    if (!current) {
      return;
    }
    current.seekTo(0);
  };

  logger.log("VideoGeneratorPreview:", "called", { playerRef, videoPlayerData });

  return (
    <div style={{ position: "relative", height: `${height}px`, width: `${width}px` }}>
      <Player
        ref={playerRef}
        id="TikTokVideo"
        component={() => TikTokVideo(videoPlayerData)}
        durationInFrames={DURATION_IN_FRAMES}
        fps={TIKTOK_VIDEO_FPS}
        compositionWidth={1080}
        compositionHeight={1920}
        style={{ height: `${height}px`, width: `${width}px`, borderRadius: "8px" }}
        autoPlay={false}
        controls={true}
        loop={true}
      />
    </div>
  );
};

export default VideoGeneratorPreview;
